import React from 'react'
import { useAppDispatch, useAppSelector } from '../store/hooks'
import {
  closeGlobalToast,
  selectGlobalToastState,
} from '../store/slices/globalToastSlice'
import { ThemeWrapper, PAYPAL_THEME, Toast } from '@paypalcorp/pp-react'
import Portal from './Portal'

const GlobalToast = () => {
  const globalToastState = useAppSelector(selectGlobalToastState)
  const dispatch = useAppDispatch()

  const handleClose = () => {
    dispatch(closeGlobalToast())
  }

  if (!globalToastState.isShown) {
    return null
  }

  return (
    <Portal>
      <ThemeWrapper theme={PAYPAL_THEME}>
        <Toast
          data-testid="globalToast"
          id={globalToastState.id}
          message={globalToastState.message}
          isSuccess={globalToastState.isSuccess}
          onClose={handleClose}
        />
      </ThemeWrapper>
    </Portal>
  )
}

export default GlobalToast
